import {
  GetRoutePathProps,
  Module,
  RoutesByModule,
  checkIsRoutePath,
  getDefaultRouteNameFromModule,
  getLocalePrefix,
  getPath,
  getRoutePath,
  unspecifiedSlugString,
  unspecifiedTypeString,
  useDefaultRoutePath,
  useRoutePaths,
} from "./getRoutePaths";

export {
  getPath,
  getRoutePath,
  unspecifiedTypeString,
  unspecifiedSlugString,
  useRoutePaths,
  getLocalePrefix,
  useDefaultRoutePath,
  getDefaultRouteNameFromModule,
  checkIsRoutePath,
};

export type { RoutesByModule, Module, GetRoutePathProps };
